import { toast } from 'react-toastify';
import Service from '../service';

export default class ContractService extends Service {
  baseApi = '/user/contracts';
  archiveApi = '/user/contract-archive';

  async getContracts(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }

  async createContract(data) {
    const url = `${this.baseApi}`;
    return await this.postResource(url, data);
  }

  async updateContract(data) {
    const url = `${this.baseApi}`;
    return await this.putResource(url, data);
  }

  async getTons(query) {
    const url = `${this.baseApi}/tons`;
    return await this.getResource(url, query);
  }

  async getProductsTons(query) {
    const url = `${this.baseApi}/products/tons`;
    return await this.getResource(url, query);
  }

  async importContract(formData) {
    const url = `${this.baseApi}/import`;
    const response = await this.postFormData(url, formData);
    if (response && Array.isArray(response.contracts)) {
      if (response.updatedCount > 0) {
        if (response.updatedCount > 1) {
          toast.success(`Договоров успешно обновлено: ${response.updatedCount}`);
          return response;
        }
        const updatedName = response.updatedContracts && response.updatedContracts[0];
        const contractLabel = updatedName ? ` "${updatedName}"` : '';
        toast.success(`Договор${contractLabel} успешно обновлен`);
      } else {
        toast.success(`Импортировано договоров: ${response.contracts.length}`);
      }
    }
    return response;
  }

  async importBalance(formData) {
    const url = `${this.baseApi}/balance/import`;
    return await this.postFormData(url, formData);
  }

  async filter(query, field) {
    const url = `${this.baseApi}/filter/${field}`;
    return await this.getResource(url, query);
  }

  async deleteContract(id) {
    const url = `${this.baseApi}/${id}`;
    const result = await fetch(`${this.apiUrl}${url}`, {
      method: 'DELETE',
      ...this.defineHeaders,
      ...this.defineCredentials,
    });
    if (!result.ok) {
      const body = await result.json().catch(() => ({}));
      toast.error(body.message || 'Ошибка удаления');
      return null;
    }
    const response = await result.json();
    if (response && response.message) {
      toast.success(response.message.trim());
    }
    return response;
  }

  async getArchivableCount(query = {}) {
    const url = `${this.archiveApi}/archivable-count`;
    return await this.getResource(url, query);
  }

  async executeArchive(data = {}) {
    const url = `${this.archiveApi}/execute`;
    return await this.postResource(url, data);
  }
}
